export default {
  keyboard: [
    { note: 43, onset: 3281 },
    { note: 71, onset: 3692 },
    { note: 67, onset: 3692 },
    { note: 62, onset: 3697 },
    { note: 67, onset: 4078 },
    { note: 71, onset: 4083 },
    { note: 62, onset: 4093 },
    { note: 38, onset: 4447 },
    { note: 67, onset: 4843 },
    { note: 71, onset: 4843 },
    { note: 62, onset: 4854 },
    { note: 67, onset: 5229 },
    { note: 71, onset: 5229 },
    { note: 62, onset: 5239 },
    { note: 43, onset: 5625 },
    { note: 71, onset: 6031 },
    { note: 67, onset: 6036 },
    { note: 62, onset: 6041 },
    { note: 67, onset: 6421 },
    { note: 71, onset: 6427 },
    { note: 62, onset: 6432 },
    { note: 38, onset: 6791 },
    { note: 71, onset: 7187 },
    { note: 67, onset: 7187 },
    { note: 62, onset: 7197 },
    { note: 71, onset: 7572 },
    { note: 67, onset: 7572 },
    { note: 62, onset: 7578 },
    { note: 43, onset: 7963 },
    { note: 67, onset: 8375 },
    { note: 71, onset: 8375 },
    { note: 62, onset: 8380 },
    { note: 67, onset: 8760 },
    { note: 71, onset: 8765 },
    { note: 62, onset: 8770 },
    { note: 38, onset: 9130 },
    { note: 67, onset: 9526 },
    { note: 71, onset: 9526 },
    { note: 62, onset: 9536 },
    { note: 67, onset: 9911 },
    { note: 71, onset: 9911 },
    { note: 62, onset: 9916 },
    { note: 43, onset: 10317 },
    { note: 62, onset: 10697 },
    { note: 67, onset: 10697 },
    { note: 59, onset: 10708 },
    { note: 67, onset: 11093 },
    { note: 62, onset: 11104 },
    { note: 59, onset: 11109 },
    { note: 38, onset: 11484 },
    { note: 67, onset: 11895 },
    { note: 59, onset: 11901 },
    { note: 62, onset: 11901 },
    { note: 62, onset: 12291 },
    { note: 67, onset: 12291 },
    { note: 59, onset: 12296 },
    { note: 36, onset: 12697 },
    { note: 64, onset: 13057 },
    { note: 67, onset: 13062 },
    { note: 60, onset: 13067 },
    { note: 67, onset: 13458 },
    { note: 64, onset: 13463 },
    { note: 60, onset: 13468 },
    { note: 36, onset: 13859 },
    { note: 64, onset: 14229 },
    { note: 67, onset: 14234 },
    { note: 60, onset: 14239 },
    { note: 64, onset: 14630 },
    { note: 60, onset: 14630 },
    { note: 67, onset: 14630 },
    { note: 43, onset: 15026 },
    { note: 67, onset: 15385 },
    { note: 62, onset: 15385 },
    { note: 59, onset: 15385 },
    { note: 62, onset: 15796 },
    { note: 67, onset: 15802 },
    { note: 59, onset: 15807 },
    { note: 43, onset: 16223 },
    { note: 59, onset: 16598 },
    { note: 62, onset: 16598 },
    { note: 67, onset: 16598 },
    { note: 62, onset: 16989 },
    { note: 67, onset: 16989 },
    { note: 59, onset: 17000 },
    { note: 38, onset: 17401 },
    { note: 66, onset: 17765 },
    { note: 62, onset: 17770 },
    { note: 69, onset: 17776 },
    { note: 60, onset: 17781 },
    { note: 66, onset: 18151 },
    { note: 69, onset: 18161 },
    { note: 62, onset: 18166 },
    { note: 60, onset: 18166 },
    { note: 45, onset: 18572 },
    { note: 69, onset: 18947 },
    { note: 66, onset: 18947 },
    { note: 62, onset: 18958 },
    { note: 60, onset: 19015 },
    { note: 69, onset: 19333 },
    { note: 66, onset: 19333 },
    { note: 62, onset: 19338 },
    { note: 60, onset: 19343 },
    { note: 43, onset: 19755 },
    { note: 67, onset: 20130 },
    { note: 62, onset: 20130 },
    { note: 59, onset: 20135 },
    { note: 67, onset: 20510 },
    { note: 59, onset: 20515 },
    { note: 62, onset: 20520 },
    { note: 40, onset: 20901 },
    { note: 62, onset: 21260 },
    { note: 64, onset: 21265 },
    { note: 67, onset: 21270 },
    { note: 59, onset: 21276 },
    { note: 62, onset: 21671 },
    { note: 64, onset: 21671 },
    { note: 67, onset: 21671 },
    { note: 59, onset: 21677 },
    { note: 45, onset: 22083 },
    { note: 61, onset: 22447 },
    { note: 67, onset: 22453 },
    { note: 55, onset: 22463 },
    { note: 64, onset: 22463 },
    { note: 57, onset: 22468 },
    { note: 67, onset: 22848 },
    { note: 64, onset: 22848 },
    { note: 61, onset: 22848 },
    { note: 55, onset: 22859 },
    { note: 57, onset: 22859 },
    { note: 45, onset: 23270 },
    { note: 61, onset: 23619 },
    { note: 64, onset: 23635 },
    { note: 67, onset: 23640 },
    { note: 55, onset: 23645 },
    { note: 57, onset: 23651 },
    { note: 61, onset: 24015 },
    { note: 64, onset: 24026 },
    { note: 55, onset: 24036 },
    { note: 67, onset: 24036 },
    { note: 57, onset: 24036 },
    { note: 38, onset: 24442 },
    { note: 66, onset: 24817 },
    { note: 60, onset: 24828 },
    { note: 64, onset: 25218 },
    { note: 67, onset: 25218 },
    { note: 69, onset: 25619 },
    { note: 62, onset: 25624 },
    { note: 50, onset: 25994 },
    { note: 60, onset: 25994 },
    { note: 45, onset: 26406 },
    { note: 38, onset: 26812 },
    { note: 66, onset: 27182 },
    { note: 69, onset: 27192 },
    { note: 62, onset: 27192 },
    { note: 60, onset: 27192 },
    { note: 69, onset: 27572 },
    { note: 62, onset: 27583 },
    { note: 66, onset: 27583 },
    { note: 60, onset: 27588 },
    { note: 45, onset: 27973 },
    { note: 66, onset: 28322 },
    { note: 69, onset: 28328 },
    { note: 62, onset: 28328 },
    { note: 60, onset: 28338 },
    { note: 62, onset: 28750 },
    { note: 69, onset: 28750 },
    { note: 66, onset: 28750 },
    { note: 60, onset: 28755 },
    { note: 43, onset: 29135 },
    { note: 69, onset: 29505 },
    { note: 64, onset: 29505 },
    { note: 60, onset: 29515 },
    { note: 59, onset: 29901 },
    { note: 67, onset: 29901 },
    { note: 62, onset: 29901 },
    { note: 38, onset: 30333 },
    { note: 62, onset: 30697 },
    { note: 67, onset: 30703 },
    { note: 59, onset: 30708 },
    { note: 67, onset: 31078 },
    { note: 62, onset: 31083 },
    { note: 59, onset: 31088 },
    { note: 43, onset: 31510 },
    { note: 62, onset: 31869 },
    { note: 67, onset: 31875 },
    { note: 59, onset: 31880 },
    { note: 67, onset: 32276 },
    { note: 62, onset: 32276 },
    { note: 59, onset: 32302 },
    { note: 36, onset: 32682 },
    { note: 60, onset: 33041 },
    { note: 64, onset: 33046 },
    { note: 55, onset: 33046 },
    { note: 64, onset: 33458 },
    { note: 60, onset: 33458 },
    { note: 55, onset: 33463 },
    { note: 43, onset: 33854 },
    { note: 59, onset: 34223 },
    { note: 62, onset: 34234 },
    { note: 55, onset: 34239 },
    { note: 59, onset: 34614 },
    { note: 62, onset: 34619 },
    { note: 55, onset: 34630 },
    { note: 38, onset: 35036 },
    { note: 54, onset: 35406 },
    { note: 60, onset: 35406 },
    { note: 62, onset: 35411 },
    { note: 62, onset: 35828 },
    { note: 60, onset: 35828 },
    { note: 54, onset: 35833 },
    { note: 43, onset: 36234 },
    { note: 67, onset: 36583 },
    { note: 62, onset: 36583 },
    { note: 59, onset: 36593 },
    { note: 67, onset: 36947 },
    { note: 62, onset: 36953 },
    { note: 59, onset: 36963 },
    { note: 38, onset: 37380 },
    { note: 66, onset: 37723 },
    { note: 69, onset: 37739 },
    { note: 62, onset: 37744 },
    { note: 60, onset: 37750 },
    { note: 43, onset: 38546 },
    { note: 67, onset: 38947 },
    { note: 62, onset: 38947 },
    { note: 59, onset: 38958 },
    { note: 67, onset: 39343 },
    { note: 59, onset: 39348 },
    { note: 62, onset: 39348 },
    { note: 38, onset: 39765 },
    { note: 66, onset: 40125 },
    { note: 69, onset: 40130 },
    { note: 60, onset: 40135 },
    { note: 62, onset: 40135 },
    { note: 47, onset: 40880 },
    { note: 62, onset: 41291 },
    { note: 67, onset: 41291 },
    { note: 59, onset: 41296 },
    { note: 62, onset: 41687 },
    { note: 67, onset: 41687 },
    { note: 59, onset: 41697 },
    { note: 50, onset: 42093 },
    { note: 69, onset: 42473 },
    { note: 66, onset: 42473 },
    { note: 62, onset: 42484 },
    { note: 60, onset: 42489 },
    { note: 38, onset: 42854 },
    { note: 43, onset: 43286 }
  ],
  vocals: [
    { note: 74, onset: 7953 },
    { note: 71, onset: 9140 },
    { note: 67, onset: 10296 },
    { note: 62, onset: 11500 },
    { note: 64, onset: 12718 },
    { note: 66, onset: 13083 },
    { note: 67, onset: 13458 },
    { note: 64, onset: 13859 },
    { note: 67, onset: 14609 },
    { note: 62, onset: 15020 },
    { note: 69, onset: 17369 },
    { note: 74, onset: 18546 },
    { note: 71, onset: 19734 },
    { note: 67, onset: 20916 },
    { note: 64, onset: 22088 },
    { note: 66, onset: 22463 },
    { note: 67, onset: 22843 },
    { note: 69, onset: 23244 },
    { note: 71, onset: 24010 },
    { note: 69, onset: 24432 },
    { note: 71, onset: 26385 },
    { note: 72, onset: 26770 },
    { note: 71, onset: 27166 },
    { note: 69, onset: 27557 },
    { note: 74, onset: 27979 },
    { note: 71, onset: 28750 },
    { note: 69, onset: 29140 },
    { note: 67, onset: 29531 },
    { note: 69, onset: 31072 },
    { note: 71, onset: 31494 },
    { note: 67, onset: 32286 },
    { note: 64, onset: 32671 },
    { note: 67, onset: 33416 },
    { note: 64, onset: 33838 },
    { note: 62, onset: 34208 },
    { note: 62, onset: 35791 },
    { note: 67, onset: 36208 },
    { note: 71, onset: 37000 },
    { note: 69, onset: 37359 },
    { note: 67, onset: 38536 },
    { note: 71, onset: 39343 },
    { note: 69, onset: 39750 },
    { note: 71, onset: 40489 },
    { note: 72, onset: 40682 },
    { note: 74, onset: 40880 },
    { note: 71, onset: 41281 },
    { note: 67, onset: 41671 },
    { note: 69, onset: 42062 },
    { note: 62, onset: 42880 },
    { note: 67, onset: 43244 }
  ]
};
